import { ProductSupplierDoc } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { useEffect } from 'react';

import useSWRProductSupplier from 'src/hooks/swr/useSWRProductSupplier';

interface AgCellProductSupplierProps extends ICellRendererParams {
  productSupplierId: string;
  field: keyof ProductSupplierDoc;
}

const AgCellProductSupplier = (params: AgCellProductSupplierProps) => {
  const productSupplierId = params.productSupplierId;
  const { supplier } = useSWRProductSupplier(productSupplierId);
  const value = (supplier?.[params.field] ?? '') as string;

  useEffect(() => {
    if (params.setValue) {
      params.setValue(value);
    }
  }, [params, value]);

  return <span>{value}</span>;
};

export default AgCellProductSupplier;
